// import React,{lazy} from "react";
import SideBar from "../Components/Main/sidebar";
import SearchBar from "../Components/Main/searchBar";
import "../Styles/mainLayout.css";
import GreetingText from "../Components/Main/greetingText"
const MainLayout = ({ children }) => {

  return (
    <div className="main-container">
      <div className="left-container">
        <SideBar /> 
      </div>
      <div className="right-contianer">
        <div className="rightContainer1">
          <div className="greet_container">
            <GreetingText />
          </div>
          <div className="search_container">
            <SearchBar />
          </div>
        </div>
        <div className="outlet-contanier">
          {children}
          </div>
      </div>
    </div>
  );
};

export default MainLayout;
